import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { ReactNode } from 'react'

import { XIcon } from '../../../icons'
import { InputProps } from '.'
import BaseInput from './base-input'
import { getBaseInputProps } from './input-props'
import { InputTooltip } from './input-tooltip'
import InputWrapper from './input-wrapper'

const TextInput: React.FC<InputProps & { tooltipContent?: string | ReactNode }> = ({
  label,
  active,
  icon,
  iconStyle,
  errorMessage,
  wrapperClassName,
  tooltipContent,
  ...props
}) => {
  const isActive = active || !!props.value
  const baseInputProps = getBaseInputProps(props)

  return (
    <InputWrapper
      label={label}
      active={isActive}
      icon={icon}
      iconStyle={iconStyle}
      errorMessage={errorMessage}
      wrapperClassName={wrapperClassName}
      {...props}
    >
      {(_, setIsActive) => (
        <div className="flex items-center justify-between gap-2">
          <BaseInput {...baseInputProps} aria-label={label} setIsActive={setIsActive} />
          {props.options?.clear && props.value && (
            <XIcon
              onClick={() => {
                const event = { target: { value: '' } } as React.ChangeEvent<HTMLInputElement>
                props.onChange?.(event)
              }}
              className="cursor-pointer"
              color={tailwindColors.grey.lighter}
              width="18px"
              height="18px"
            />
          )}
          {tooltipContent && <InputTooltip>{tooltipContent}</InputTooltip>}
        </div>
      )}
    </InputWrapper>
  )
}

export default TextInput
